import { httpTokenCommon } from "../helper/http-common";
import { DeliveryFilterParams } from "../types/deliveryManagement";

class DeliveryServices {
  getDeliveryDashboardData() {
    return httpTokenCommon.get(`deliveries/dashboard`);
  }
  getDeliveryList(params: DeliveryFilterParams) {
    return httpTokenCommon.get("deliveries/search", { params });
  }
}

const deliveryServices = new DeliveryServices();
export default deliveryServices;
